<template>
  <localization :language="localizationLanguage">
    <intl :locale="locale">
      <router-view :localization-language="localizationLanguage" :current-theme="currentTheme"></router-view>
      <AppNotifications />
    </intl>
  </localization>
</template>

<script>
import '@progress/kendo-theme-default/dist/all.css';

import { enComponentMessages, enCustomMessages } from "./messages/en-US";
import { ruComponentMessages, ruCustomMessages } from "./messages/ru-RU";

import {
  load,
  LocalizationProvider,
  IntlProvider,
  loadMessages,
} from "@progress/kendo-vue-intl";

import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";

import numbers from "cldr-numbers-full/main/es/numbers.json";
import caGregorian from "cldr-dates-full/main/es/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/es/dateFields.json";
import timeZoneNames from "cldr-dates-full/main/es/timeZoneNames.json";
import esNumbers from "cldr-numbers-full/main/es/numbers.json";
import esCurrencies from "cldr-numbers-full/main/es/currencies.json";

import frNumbers from "cldr-numbers-full/main/fr/numbers.json";
import frCaGregorian from "cldr-dates-full/main/fr/ca-gregorian.json";
import frDateFields from "cldr-dates-full/main/fr/dateFields.json";
import frTimeZoneNames from "cldr-dates-full/main/fr/timeZoneNames.json";
import frCurrencies from "cldr-numbers-full/main/fr/currencies.json";

import api from '@/api';

// Добавляем импорт русской локализации
import ruNumbers from "cldr-numbers-full/main/ru/numbers.json";
import ruCaGregorian from "cldr-dates-full/main/ru/ca-gregorian.json";
import ruDateFields from "cldr-dates-full/main/ru/dateFields.json";
import ruTimeZoneNames from "cldr-dates-full/main/ru/timeZoneNames.json";
import ruCurrencies from "cldr-numbers-full/main/ru/currencies.json";

import AppNotifications from './components/AppNotifications.vue'

import { useAppStore } from "@/stores/app";


load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  caGregorian,
  dateFields,
  timeZoneNames,
  esNumbers,
  esCurrencies,
  frNumbers,
  frCaGregorian,
  frDateFields,
  frTimeZoneNames,
  frCurrencies,
  ruNumbers,
  ruCaGregorian,
  ruDateFields,
  ruTimeZoneNames,
  ruCurrencies
);

loadMessages(enCustomMessages, "English");
loadMessages(enComponentMessages, "English");
loadMessages(ruCustomMessages, "Russian");
loadMessages(ruComponentMessages, "Russian");


export default {
  name: "app",
  components: {
    localization: LocalizationProvider,
    intl: IntlProvider,
    AppNotifications
  },
  data() {
    return {
      localizationLanguage: "Russian",
      currentTheme: "Default",
      api: api
    };
  },
  methods: {
    onLocaleChange(e) {
      const appStore = useAppStore();
      appStore.setLang(e.language);

      this.localizationLanguage = e.language;
      this.intl.locale = e.language;
    },
    onThemeChange(e) {
      this.currentTheme = e;
    },
  },
  computed: {
    locale() {
      if (this.localizationLanguage === "Spanish") {
        return "es";
      }

      if (this.localizationLanguage === "Russian") {
        return "ru";
      }


      if (this.localizationLanguage === "French") {
        return "fr";
      }

      return "ru";
    },
  },
};
</script>

<style lang="scss">
@import "./assets/styles/app.scss";

.column {
  display: inline-block;
}

.column.content {
  min-width: 500px;
}


.k-item.k-menu-item.k-drawer-item.k-state-selected {
  color: #ffffff;
}

.content-wrapper {
  display: grid;
  grid-template-columns: 220px 1fr;
}

.k-drawer-container.k-drawer-push {
  display: inherit;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>